import React, { Component } from "react"
import "./index.css"

class CopyRight extends Component {
  render() {
    return (
      <div className="row copyright-row">
        <div className="col-12 text-center">
          <p className="footer-copyright">© Copyright 2019: TaxiOnSpot</p>
        </div>
      </div>
    )
  }
}

export default CopyRight
